export const DONE = 'done';
export const NOT_DONE = 'not_done';
export const NONE = 'none';

